// extracted by mini-css-extract-plugin
export var backLink = "TicketingTicketDetailPage-module__backLink___B0gpI";
export var container = "TicketingTicketDetailPage-module__container___6gqK9";
export var innerContainer = "TicketingTicketDetailPage-module__innerContainer___nF-JM";
export var outerContainer = "TicketingTicketDetailPage-module__outerContainer___MIv6+";
export var spinnerContainer = "TicketingTicketDetailPage-module__spinnerContainer___IRfOf";
export var teamLabel = "TicketingTicketDetailPage-module__teamLabel___oNFJx";
export var teamName = "TicketingTicketDetailPage-module__teamName___tmyyL";
export var topBar = "TicketingTicketDetailPage-module__topBar___LcslP";